<div class="card">
  <div class="card-body">
    <h5 class="mb-3"><b><i class="fas fa-unlock-alt"></i> Change Password  </b></h5>
    <div class="col-12">
      <div class="col-7  align-items-center mx-auto">
        <form [formGroup]="pwForm">

          <input formControlName="oldpw" class="form-control mb-3" placeholder="Password" type="password">

          <input
            [ngClass]="{'is-invalid' : pwForm.get('password').hasError('required') && pwForm.get('password').touched || !pwForm.controls.password.valid && pwForm.controls.password.dirty }"
            formControlName="password" class="form-control password-padding password-border"
            placeholder="Enter your password" [type]="'password'">
          <p class="validation-p"
             [ngClass]="{'display-validation' : pwForm.get('password').hasError('required') && pwForm.get('password').touched || !pwForm.controls.password.valid && pwForm.controls.password.dirty }">
            *Password must be at least <strong> 8 characters</strong> long..</p>

          <input
            [ngClass]="{'is-invalid' : pwForm.get('confirmPassword').hasError('required') && pwForm.get('confirmPassword').touched || !pwForm.controls.confirmPassword.valid && pwForm.controls.confirmPassword.dirty || pwForm.hasError('notSame') && pwForm.get('confirmPassword').touched  }"
            formControlName="confirmPassword" class="form-control password-padding password-border"
            placeholder="Confirm your password" [type]="'password'">


          <p class="validation-p"
             [ngClass]="{'display-validation' : pwForm.get('confirmPassword').hasError('required') && pwForm.get('confirmPassword').touched || !pwForm.controls.confirmPassword.valid && pwForm.controls.confirmPassword.dirty || pwForm.hasError('notSame') && pwForm.get('confirmPassword').touched  }">
            *Passwords <strong>do not match.</strong></p>


          <div class="text-center mb-3">
            <button class="btn  btn-block btn-success ladda-button" data-style="slide-up"
                    [ladda]="isLoading" [disabled]="!pwForm.valid"  (click)="change()">
              <span class="ladda-label"> Change </span>
              <span class="ladda-spinner"></span>
              <div class="ladda-progress" style="width: 0px;"></div>
            </button>
          </div>
          <div class="row mb-3">

            <div class="col-12">
              <div class="or-image"></div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<notifier-container></notifier-container>
